import * as React from 'react';

type Tema = 'claro' | 'escuro';

const CHAVE = 'wms.tema';

function temaInicial(): Tema {
  try {
    const salvo = localStorage.getItem(CHAVE);
    if (salvo === 'claro' || salvo === 'escuro') return salvo;
  } catch {
    /* storage bloqueado */
  }
  // Cliente aprovou o tema claro do getSefaz e rejeitou o escuro: claro é o
  // padrão, independente da preferência do SO. Dark continua acessível pelo
  // toggle do header.
  return 'claro';
}

interface ValorTema {
  tema: Tema;
  escuro: boolean;
  alternar: () => void;
}

const ContextoTema = React.createContext<ValorTema | null>(null);

export function ProvedorTema({ children }: { children: React.ReactNode }): JSX.Element {
  const [tema, definirTema] = React.useState<Tema>(temaInicial);

  React.useEffect(() => {
    document.documentElement.classList.toggle('dark', tema === 'escuro');
    try {
      localStorage.setItem(CHAVE, tema);
    } catch {
      /* storage bloqueado */
    }
  }, [tema]);

  const valor = React.useMemo<ValorTema>(
    () => ({
      tema,
      escuro: tema === 'escuro',
      alternar: () => definirTema((t) => (t === 'escuro' ? 'claro' : 'escuro')),
    }),
    [tema],
  );

  return <ContextoTema.Provider value={valor}>{children}</ContextoTema.Provider>;
}

export function useTema(): ValorTema {
  const valor = React.useContext(ContextoTema);
  if (!valor) throw new Error('useTema precisa estar dentro de <ProvedorTema>.');
  return valor;
}
